import HttpClient, {HttpClientConfig} from 'axios-mapper';
import {getAccessToken, getRefreshToken} from "@/utils/auth";
import settings from "@/config/settings.config";
import { ElMessage } from 'element-plus'

const handle401 = () => {
    window.localStorage.removeItem('refreshToken');
    window.localStorage.removeItem('accessToken');
    window.location.replace('/login?path=' + encodeURIComponent(window.location.href));
};

const https = (hasToken: boolean):HttpClient => {
    const httpConfig: HttpClientConfig = {
        baseURL: settings.baseURL,
        timeout: 30000,
        headers: {
            'x-access-token': hasToken ? getAccessToken(): '',
            'x-refresh-token': hasToken ? getRefreshToken(): '',
        },
    };
    const client = new HttpClient(httpConfig);

    client.httpClient.interceptors.request.use(
        config => {
            // 避免get缓存增加时间戳
            if (config.method === "get") {
                if (!config.params) {
                    config.params = {};
                }
                config.params.t = new Date().getTime();
            }
            return config;
        }, error => {
            return Promise.reject(error);
        });

    client.httpClient.interceptors.response.use(
        response => {
          const res = response.data;
            if (res.code !== 200 && res.code < 1000) {
                if (res.code === 401) {
                    handle401()
                } else {
                  ElMessage.error?.(res.msg);
                }
                return Promise.reject(res.msg);
            } else {
                return response;
            }
        }, error => {
            return Promise.reject(error);
        }
    );

    return client;
};

export default https;
